import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { googleLogin } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    if (!sessionId) {
      navigate("/admin/login", { replace: true, state: { error: "Google sign-in did not complete. Please try again." } });
      return;
    }
    googleLogin(sessionId)
      .then((user) => navigate("/admin", { replace: true, state: { user } }))
      .catch((err) =>
        navigate("/admin/login", {
          replace: true,
          state: { error: apiError(err, "Google sign-in failed. Please try again.") },
        })
      );
  }, [location.hash, googleLogin, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-navy" data-testid="auth-callback">
      <div className="text-center">
        <div className="mx-auto h-8 w-8 animate-spin rounded-full border-2 border-cream/30 border-t-gold" aria-label="Signing in" />
        <p className="mt-4 text-sm text-cream/70">Completing Google sign-in…</p>
      </div>
    </div>
  );
}
